module.exports = __webpack_public_path__ + "static/media/globe-fill.8e0ad8f8.png";